import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import { Colors } from '@/components/ui/types';

import { ProgressProps } from './types';

const colorClasses: Record<Colors, string> = {
  default: '',
  neutral: 'progress-neutral',
  primary: 'progress-primary',
  secondary: 'progress-secondary',
  accent: 'progress-accent',
  info: 'progress-info',
  success: 'progress-success',
  warning: 'progress-warning',
  error: 'progress-error',
};

export const Progress = forwardRef<HTMLProgressElement, ProgressProps>(
  ({ className, value, color = 'default', max = 100, ...props }, ref) => {
    const classes = twMerge('progress', colorClasses[color], className);

    return (
      <progress
        ref={ref}
        className={classes}
        value={value}
        max={max}
        {...props}
      />
    );
  },
);

Progress.displayName = 'Progress';
